import 'bootstrap/dist/css/bootstrap.css' 
import 'vue-search-select/dist/VueSearchSelect.css'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueMask from 'v-mask'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use(VueMask);

// Função pra executar requisições, acesso global através de this.$run_axios('get', '/foo', bar)
Vue.prototype.$run_axios =  function(method, uri, data = {}) {
  return new Promise( resolve => {
    let api = process.env.VUE_APP_API;
  
    let token = localStorage.jwt;
  
    var url = api + '/api' + uri
  
    axios({
      method: method,
      url: url,
      data: data,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json"
      }
    })
    .then(response => {
      resolve (response.data);
    })
    .catch(response => {
      if (response.response.status == 403){
        alert('Sua sessão expirou.')
        const redirect = JSON.parse(localStorage.application)
        window.location.href = `http://${redirect.callback_url}`
        localStorage.clear()
      }
      resolve (false);
    });

  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
